import { Provider } from "react-redux";
import "./App.css";
import store from "./redux/store";
import AppRoutes from "./routes";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "./components/LanguageContext/themeContext";

const App = () => {
  return (
    <>
      <Provider store={store}>
        <BrowserRouter>
          <ThemeProvider>
            <AppRoutes />
          </ThemeProvider>
        </BrowserRouter>
      </Provider>
    </>
  );
};

export default App;
